import { number, string, shape, oneOf } from 'prop-types';

export const brushType = shape({
  label: oneOf(['fine', 'marker']).isRequired,
  opacity: string.isRequired,
  brushRadius: number.isRequired
});

export const colorType = string;
